import { combineReducers } from "redux";

import UserReducer from "./UserReducer";
const appReducer = combineReducers({
  UserReducer,
});

export default appReducer;

export type State = ReturnType<typeof appReducer>;
